import { router } from '@inertiajs/react';
import useRoute from '@/Hooks/useRoute';

export default function useRequests() {
  const route = useRoute();

  function post(
    routeName: string,
    params: any = {},
    data: any = {},
    options: any = {},
  ) {
    router.post(route(routeName, params), data, options);
  }

  return { post };
}
